<span class="app-tooltip">
  <span class="app-tooltip-trigger">
    <ng-content></ng-content>
  </span>
</span>
